let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dil5i")).then(() => parcelRequire('fX9Sa'));